<!-- 考证辅导题库选题组件 -->
<template>
  <el-dialog
    title="选择题库"
    v-if="seeQuestionShow"
    :append-to-body="true"
    :visible.sync="seeQuestionShow"
    width="930px"
  >
    <span slot="title">
      <i class="el-icon-s-check" style="margin-right: 10px;color: #67C23A;"></i>选择题库
    </span>
    <el-input style="width: 200px;" placeholder="请输入题干名称" v-model="searchQ.questionStem">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <label class="ml10">归属课程：</label>
    <el-select clearable style="width: 190px;" v-model="searchQ.courseMergeCourseInfoId" placeholder="请选择归属课程">
      <template v-for="(item ,index) in courseMergeList">
        <el-option :label="item.courseIdText || item.courseTitle" :value="item.courseMergeCourseInfoId"></el-option>
      </template>
    </el-select>
    <label class="ml10">题型：</label>
    <el-select clearable v-model="searchQ.questionType" style="width: 120px;" placeholder="请选择题型">
      <el-option label="单选题" value="1"></el-option>
      <el-option label="多选题" value="2"></el-option>
      <el-option label="判断题" value="3"></el-option>
      <el-option label="填空题" value="4"></el-option>
      <el-option label="分析题" value="5"></el-option>
    </el-select>
    <el-button type="primary" icon="el-icon-search" @click="getQuestionList(page = 1)">搜索</el-button>
    <el-button type="danger" @click="clearSelect">清除已选</el-button>
    <el-table
      :data="newTabledata"
      border
      :row-key="getRowKeys"
      ref="multipleTable"
      @selection-change="questionChange"
      style="width: 100%;margin-top: 10px;">
       <el-table-column type="selection" width="50" :reserve-selection="true" header-align="center" align="center"></el-table-column>
      <el-table-column prop="questionStem" header-align="center" align="left" label="题干">
        <template slot-scope="scope">
          <el-row v-html="$getReplace(scope.row.questionStem)"></el-row>
        </template>
      </el-table-column>
      <el-table-column prop="questionType" header-align="center" align="center" label="题型" width="100px">
        <!-- (1单选 2多选 3判断) -->
        <template slot-scope="scope">
          {{$retQuestionType(scope.row.questionType)}}
        </template>
      </el-table-column>
      <el-table-column prop="courseInfoParentName" header-align="center" align="center" label="归属课程" width="130px"> </el-table-column>
      <el-table-column prop="courseInfoName" header-align="center" align="center" width="130px" label="归属章节"> </el-table-column>
    </el-table>
    <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;position: relative;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        background
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
      <p style="position: absolute;left: 0;top: 0;">
        已选题目：{{getSeeNum()}}
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="seeQuestionShow = false">取 消</el-button>
      <el-button type="primary" @click="submitSeeQuestion">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {getCourseMergeList,getCoachQuestionList} from "@/common/getInfo";	//加载数据
export default {
		name:"coachQuestion",
		props: {
			handsOnId: {
			  type: String,
			  default: function(){
          return null;
        }
			},
			courseId: {
			  type: String,
			  default: function(){
			    return "";
			  }
			},
			show: {
			  type: Boolean,
        default: function(){
          return null;
        }
			},
      onIds:{
			  type: String,
        default: function(){
          return "";
        }
			}
		},
		data() {
			return{
        seeQuestionShow:this.show,
        newTabledata:[],
        total: 0,
        limit:10,
        page:1,
        searchQ:{},
        courseMergeList:[],
        oldNum:0,
        selections: {},//存储选中行的数据
        ids:""
			}
		},
    created() {
      this.getInfo();
    },
		mounted() {
		},
		methods: {
      handleSizeChange(val) {
        this.limit = val;
        this.getQuestionList();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getQuestionList();
      },
      submitSeeQuestion() {//获取选中的行的id值
        let selections = Object.keys(this.selections);
        //由于Object.keys之后是字符串类型， 如果传递给后台的id是数字类型,需要转换过来。
        let ids = this.ids;
        let one = ids.charAt(0);
        let last = ids.charAt(ids.length-1);
        ids = ids.substring(one == ","?1:0,last == ","?ids.length-1:ids.length); //去掉前后逗号
        // if(this.$isEmpty(ids)){
        //   this.$message({message: '请选择题目！',type: 'warning'});
        //   return;
        // }
        this.seeQuestionShow = false;
        this.$message({type: 'success',message: '选择成功！'});
        this.$emit('onSuccess', ids); //成功的回调 返回ids字符串
      },
      getInfo(){
        this.ids = (this.$isEmpty(this.onIds)?'':(","+this.onIds+","));
        this.searchQ = {};
        this.getCourseMergeList();
        this.getQuestionList();
      },
      getQuestionList(){
        let param = {
          // handsOnId:this.handsOnId,
          page:this.page,
          limit:this.limit,
          questionStatus:1,
          courseId:this.courseId
        }
        param = Object.assign(this.searchQ,param); //合并参数对象
        getCoachQuestionList(param).then((ret) =>{
          if(ret.code == 0){
            this.total = Number(ret.count);
            this.newTabledata = ret.data;
            setTimeout(()=>{
              if(!this.$isEmpty(this.ids)){
                for(let i in this.newTabledata){
                  //判断是否存在
                  if((this.ids).indexOf(","+this.newTabledata[i].resourcesQuestionId+",")>=0){
                    this.$refs.multipleTable.toggleRowSelection(this.newTabledata[i], true); //选中
                  }
                }
              }
            },10)
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      },
      getCourseMergeList(){ //获取归属课程
        if(this.courseMergeList.length > 0){
          return;
        }
        let param = {
          //courseId:this.courseId
        }
        getCourseMergeList(param).then((ret) =>{
          if(ret.code == 0){
            this.courseMergeList = ret.data;
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      },
      closeDialog(){ //关闭时调用
        this.seeQuestionShow = false;
        this.$emit('close');
      },
      getRowKeys(row) {
        return row.resourcesQuestionId;
      },
      questionChange(val){ //表格内checkbox触发的全选按钮状态变化
        let onIds = "";
        val.forEach((item,i) => { //将选择的ID拼接起来
          onIds += item.resourcesQuestionId;
          if(i < val.length - 1){
            onIds += ",";
          }
        });
        //根据选择的onIds判断哪些是新增的，哪些不是新增的
        this.newTabledata.forEach((item,i) => {
          setTimeout(()=>{
            //所有已选不存在当前
            if(this.ids.indexOf("," + item.resourcesQuestionId + ",")<0){
              //已经存在当前选择的
              if((","+onIds+",").indexOf("," + item.resourcesQuestionId + ",") >=0){
                if(this.$isEmpty(this.ids)){
                  this.ids += ","+item.resourcesQuestionId + ',';
                }else{
                  this.ids += item.resourcesQuestionId + ',';
                }
              }
            }else{ //所有已选存在当前
              if((","+onIds+",").indexOf("," + item.resourcesQuestionId + ",") < 0){
                this.ids = this.ids.replace(',' + item.resourcesQuestionId + ',',",");
                if(this.ids == ","){
                  this.ids = "";
                }
              }
            }
          },100)
        });
      },
      // 清空选择的值
      clearSelect () {
        this.ids = "";
        this.$refs.multipleTable.clearSelection();
      },
      getSeeNum(){ //获取选择的题目数量
        let i = this.ids.split(",").length;
        if(i >= 3){
          return i - 2;
        }else{
          return i==1?0:1;
        }
      }
		},
    watch:{
      show: {
        handler (newName) {
          this.seeQuestionShow = newName;
          this.getInfo();
        },
        immediate: true
      }
    }
	}
</script>

<style lang="less">
  .language_points {
    p{
      margin: 0;line-height: 25px;text-indent: 2em;
    }
    table{
      width: 100%;
      border-collapse: collapse;
    }
    tr,td{
      border: 1px solid #EBEEF5;
      text-align: center;
      line-height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Question/coachIndex.vue